function UnderConstruction() {
    return (
        <div id="under-construction">
            <img src="/assets/images/flat-construction-sign-background.png" alt="indi" />
        </div>
    );
}

export default UnderConstruction;
